import { render, staticRenderFns } from "./CrewBasicInfor.vue?vue&type=template&id=5491fb59&scoped=true"
import script from "./CrewBasicInfor.vue?vue&type=script&lang=js"
export * from "./CrewBasicInfor.vue?vue&type=script&lang=js"
import style0 from "./CrewBasicInfor.vue?vue&type=style&index=0&id=5491fb59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5491fb59",
  null
  
)

export default component.exports